/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cl_Affects_TitleInputs */

const en_cl_affects_title = /** @type {(inputs: Cl_Affects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What this changes`)
};

const de_cl_affects_title = /** @type {(inputs: Cl_Affects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was sich dadurch ändert`)
};

/**
* | output |
* | --- |
* | "What this changes" |
*
* @param {Cl_Affects_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cl_affects_title = /** @type {((inputs?: Cl_Affects_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cl_Affects_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cl_affects_title(inputs)
	return en_cl_affects_title(inputs)
});